import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AssetUserService {
  _baseUrl = environment.baseUrl;
  constructor(private readonly http: HttpClient) {}

  getAllAssetUsers(model: any): Observable<any> {
    let options = {
      headers: new HttpHeaders({
        "x-api-version": "2.0",
      }),
      withCredentials: true,
    };
    return this.http.post<any>(
      this._baseUrl + "AssetUsers/GetAllAssetUsers",
      model,
      options
    );
  }

  saveAssetUser(model: any): Observable<any> {
    let options = {
      headers: new HttpHeaders({
        "x-api-version": "2.0",
      }),
      withCredentials: true,
    };
    return this.http.post<any>(
      this._baseUrl + "AssetUsers/AddAssetUser",
      model,
      options
    );
  }

  updateAssetUser(model: any): Observable<any> {
    let options = {
      headers: new HttpHeaders({
        "x-api-version": "2.0",
      }),
      withCredentials: true,
    };
    return this.http.post<any>(
      this._baseUrl + "AssetUsers/UpdateAssetUser",
      model,
      options
    );
  }
   
   deleteAssetUser(model: any): Observable<any> {
    let options = {
      headers: new HttpHeaders({
        "x-api-version": "2.0",
      }),
      withCredentials: true,
    };
    return this.http.post<any>(
      this._baseUrl + "AssetUsers/DeleteAssetUser",
      model,
      options
    );
  }


  getSampleBulkAssetUserFile(): any {
    let headers = new HttpHeaders({
      "x-api-version": "2.0",
    });

    let options = {
      headers: headers,
      withCredentials: true,
      responseType: "blob" as "json", // Type assertion needed for blob responses
    };

    return this.http.get(
      this._baseUrl + "AssetUsers/GetSampleBulkAssetUserFile",
      options
    );
  }

  
  uploadFileToBulkCreateAssetUsers(model: any): Observable<any> {
    let headers = new HttpHeaders({
      "x-api-version": "2.0",
    });

    let options = {
      headers: headers,
      withCredentials: true
    };

    return this.http.post<any>(
      this._baseUrl + "AssetUsers/UploadToBulkCreateAssetUsers",
      model, options
    );
  }



}
